import { Component, Inject } from '@angular/core';

@Component({
  standalone: false,
  selector: 'country-selector',
  templateUrl: './country-selector.component.html',
  styleUrls: ['./country-selector.component.scss']
})
export class CountrySelectorComponent {
  public urls: any;

  constructor(@Inject('AppConfig') _appConfig: any) {
    this.urls = _appConfig.countryDomainUrls;
    this.urls.SE = this.urls.SE || 'https://www.cakeiteasy.se/';
    this.urls.NO = this.urls.NO || 'https://www.cakeiteasy.no/';
  }
}
